// Panter's company details, as Panter publishes them. Every value here was read
// off https://www.panter.ch/impressum/ and https://www.panter.ch/datenschutz/
// (2026-10-08); none is inferred. Change them only from those pages.
//
// Two addresses, because Panter publishes two: the imprint names
// info@panter.ch, the site's footer and contact page name hello@panter.ch.
// Panter's own privacy notice sends data-protection requests "to the address
// specified in the imprint", so a privacy request goes to the imprint address.
// Panter publishes no separate data-protection officer or EU representative,
// and none is named here.

export const PANTER = {
  /** "Firmenname" in the imprint's commercial-register entry. */
  legalName: "Panter AG (Panter Ltd.)",
  name: "Panter AG",
  street: "Sihlquai 131",
  city: "8005 Zürich",
  /** The imprint's contact address; also where privacy requests go. */
  imprintEmail: "info@panter.ch",
  /** The site's general contact (footer, contact page). */
  contactEmail: "hello@panter.ch",
  phone: "+41 44 500 29 04",
  /** "Vertretungsberechtigte Personen". */
  representatives: [
    "Georgios Kontoleon",
    "Martin Mächler",
    "Beat Seeliger",
    "Christoph Birkholz",
  ],
  register: "Handelsregisteramt des Kantons Zürich",
  uid: "CHE-262.202.358",
  vat: "CHE-262.202.358 MWST",
  website: "https://www.panter.ch",
} as const;

/** The day the privacy text last changed. Bump it with any change to the text. */
export const PRIVACY_UPDATED = { en: "29 October 2026", de: "29. Oktober 2026" } as const;
